import notificationApi from '@/api/notifications';

const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_DECREASE_PRODUCT_NOTIFICATION = 'SET_DECREASE_PRODUCT_NOTIFICATION';
const SET_INCREASE_PRODUCT_NOTIFICATION = 'SET_INCREASE_PRODUCT_NOTIFICATION';
const SET_DECREASE_GENERAL_NOTIFICATION = 'SET_DECREASE_GENERAL_NOTIFICATION';
const SET_INCREASE_GENERAL_NOTIFICATION = 'SET_INCREASE_GENERAL_NOTIFICATION';
const SET_UNREAD_PRODUCT_NOTIFICATION = 'SET_UNREAD_PRODUCT_NOTIFICATION';
const SET_UNREAD_GENERAL_NOTIFICATION = 'SET_UNREAD_GENERAL_NOTIFICATION';
const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
const SET_NOTIFICATIONS_CONCAT = 'SET_NOTIFICATIONS_CONCAT';
const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
const NEXT_PAGE = 'NEXT_PAGE';
const SET_PAGE = 'SET_PAGE';
const SET_IS_ALL = 'SET_IS_ALL';
const SET_ALL_NOTIFICATIONS_PRODUCT_READED = 'SET_ALL_NOTIFICATIONS_PRODUCT_READED';
const SET_ALL_NOTIFICATIONS_GENERAL_READED = 'SET_ALL_NOTIFICATIONS_GENERAL_READED';
const SET_NOTIFICATIONS_READED = 'SET_NOTIFICATIONS_READED';
const UNSHIFT_NEW_NOTIFICATION = 'UNSHIFT_NEW_NOTIFICATION';

const state = {
	isFetching: false,
	isFetched: false,
	notifications: [],
	page: 1,
	isAll: false,
	unread: 0,
	unreadProductCount: 0,
	unreadGeneralCount: 0,
	activeTab: 'product',
};

const getters = {
	notifications: state => state?.notifications,
	notificationsHeader: state => state?.notifications?.slice(0, 10),
	isFetching: state => state?.isFetching,
	unread: state => state?.unreadGeneralCount + state?.unreadProductCount,
	unreadGeneralCount: state => state?.unreadGeneralCount,
	unreadProductCount: state => state?.unreadProductCount,
	activeTab: state => state?.activeTab,
	page: state => state?.page,
	isAll: state => state?.isAll,
};

const mutations = {
	[SET_INCREASE_PRODUCT_NOTIFICATION](state, value) {
		state.unreadProductCount += value;
	},
	[SET_DECREASE_PRODUCT_NOTIFICATION](state, value) {
		state.unreadProductCount -= value;
	},
	[SET_INCREASE_GENERAL_NOTIFICATION](state, value) {
		state.unreadGeneralCount += value;
	},
	[SET_DECREASE_GENERAL_NOTIFICATION](state, value) {
		state.unreadGeneralCount -= value;
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_NOTIFICATIONS](state, data) {
		state.notifications = data;
	},
	[SET_NOTIFICATIONS_CONCAT](state, data) {
		state.notifications = state.notifications.concat(data);
	},
	[SET_UNREAD_GENERAL_NOTIFICATION](state, data) {
		state.unreadGeneralCount = data;
	},
	[SET_UNREAD_PRODUCT_NOTIFICATION](state, data) {
		state.unreadProductCount = data;
	},
	[SET_ACTIVE_TAB](state, data) {
		state.activeTab = data;
	},
	[SET_ACTIVE_TAB](state, data) {
		state.activeTab = data;
	},
	[SET_PAGE](state, value) {
		state.page = value;
	},
	[NEXT_PAGE](state) {
		state.page += 1;
	},
	[SET_IS_ALL](state, value) {
		state.isAll = value;
	},
	[SET_ALL_NOTIFICATIONS_GENERAL_READED](state) {
		state.notifications.forEach((notification) => {
			if (notification.group === 'general') {
				notification.seen = true;
			}
		});
	},
	[SET_ALL_NOTIFICATIONS_PRODUCT_READED](state) {
		state.notifications.forEach((notification) => {
			if (notification.group === 'product') {
				notification.seen = true;
			}
		});
	},
	[SET_ALL_NOTIFICATIONS_PRODUCT_READED](state) {
		state.notifications.forEach((notification) => {
			if (notification.group === 'product') {
				notification.seen = true;
			}
		});
	},
	[SET_NOTIFICATIONS_READED](state, id) {
		const notificationToUpdate = state.notifications.find(notification => notification._id === id[0]);

		if (notificationToUpdate) {
			notificationToUpdate.seen = true;
		}
	},
	[UNSHIFT_NEW_NOTIFICATION](state, value) {
		state.notifications.unshift(value);
	},
};

const actions = {
	getNotifications({ commit, getters }, data) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			if (data?.reset === true) {
				commit(SET_NOTIFICATIONS, []);
			}
			const callback = (response) => {
				const notifications = response.data?.lists || [];
				const unreadGeneral = response.data?.unread_general || 0;
				const unreadProduct = response.data?.unread_product || 0;

				commit(SET_UNREAD_GENERAL_NOTIFICATION, unreadGeneral);
				commit(SET_UNREAD_PRODUCT_NOTIFICATION, unreadProduct);

				const isEmpty = getters.notifications.length === 0;
				if (isEmpty) {
					commit(SET_NOTIFICATIONS, notifications);
				} else {
					commit(SET_NOTIFICATIONS_CONCAT, notifications);
				}

				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
				commit(NEXT_PAGE);

				if (!getters.isFetching && notifications.length === 0) {
					commit(SET_IS_ALL, true);
				}
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			notificationApi.getList(data.params, callback, errorCallback);
		}
	},
	setNotifications({ commit }, data) {
		commit(SET_NOTIFICATIONS, data);
	},
	setActiveTab({ commit }, data) {
		commit(SET_ACTIVE_TAB, data);
	},
	decreaseUnreadProductNotification({ commit }, value) {
		commit(SET_DECREASE_PRODUCT_NOTIFICATION, value);
	},
	increaseUnreadProductNotification({ commit }, value) {
		commit(SET_INCREASE_PRODUCT_NOTIFICATION, value);
	},
	decreaseUnreadGeneralNotification({ commit }, value) {
		commit(SET_DECREASE_GENERAL_NOTIFICATION, value);
	},
	increaseUnreadGeneralNotification({ commit }, value) {
		commit(SET_INCREASE_GENERAL_NOTIFICATION, value);
	},
	setPage({ commit }, value) {
		commit(SET_PAGE, value);
	},
	setIsAll({ commit }, value) {
		commit(SET_IS_ALL, value);
	},
	unshiftNewNotification({ commit }, value) {
		commit(UNSHIFT_NEW_NOTIFICATION, value);
	},
	markAsRead({ commit, getters }, data) {
		let ids = [];
		if (data?.ids) {
			ids = data.ids;
		}

		const callback = () => {
			if (data?.ids) {
				ids = data.ids;
				commit(SET_NOTIFICATIONS_READED, ids);

				if (getters.activeTab === 'product') {
					commit(SET_DECREASE_PRODUCT_NOTIFICATION, 1);
				} else {
					commit(SET_DECREASE_GENERAL_NOTIFICATION, 1);
				}
			} else if (getters.activeTab === 'product') {
				commit(SET_ALL_NOTIFICATIONS_PRODUCT_READED);
				commit(SET_UNREAD_PRODUCT_NOTIFICATION, 0);
			} else {
				commit(SET_ALL_NOTIFICATIONS_GENERAL_READED);
				commit(SET_UNREAD_GENERAL_NOTIFICATION, 0);
			}
		};

		notificationApi.markAsRead(getters.activeTab, ids, callback);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
